import { format } from 'date-fns';
import { TimestampStyles } from './styles';

export default function LastUpdateTimestamp({ timestamp }: { timestamp: string }) {
  return (
    <TimestampStyles>
      Last Edited On: {format(new Date(timestamp), 'EEEE, MMMM d, yyyy, h:mm a')}
    </TimestampStyles>
  );
}